// delete with removal of contentTypeMenuUpdate FF
import { connect } from 'react-redux';
import { defaultMemoize } from 'reselect';
import _ from 'underscore';

import { GenericMenuItemInfo } from '@tableau/widgets';

import { getMixedContentInOrder } from '../../../contentDefinitionInterfaces/ContentDefinitionsLists';

import { FeatureFlags } from '../../../ts/FeatureFlags';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { ISpaceInfoTypeItemCount, SpaceInfoTypeContentCounts } from '../../state/ContentCountsState';

import { Messages } from '../../../codegen/Localize';
import { selectContentCounts } from '../../selectors/ContentCountsSelector';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedFilterByTypeMenuHelpers } from '../Components/ConnectedFilterByTypeMenuHelpers';
import { ExplorerDropdownItemHeaderFormatter, ExplorerDropdownItemNoCountFormatter, ExplorerDropdownSeparatorFormatter } from '../Components/ExplorerDropdownPanelItems';
import { ExplorerListMenuPanel, ExplorerListMenuPanelOwnProps, ExplorerListMenuPanelStateProps } from '../Components/ExplorerListMenuPanel';
import { MixedContentItemDefinition } from '../../../contentDefinitionInterfaces/ContentDefinitionsTypes';

export const ShowWorkbookAsViewsValue = 'showWorkbooksAsViews';

export const getContentDefinitionsForProjectSpaceMenu = (
  showWorkbooksAsViews: boolean,
  flowsEnabled: boolean
): MixedContentItemDefinition[] => {
  const items: MixedContentItemDefinition[] = [];

  const mixedContentInOrder = getMixedContentInOrder();

  for (const typeDef of mixedContentInOrder) {
    if (
      (flowsEnabled || typeDef.itemType !== 'flow') &&
      (typeDef.itemType !== 'metric'|| FeatureFlags.metricsSpaceEnabled) &&
      (typeDef.itemType !== 'lens'|| FeatureFlags.nlplensContentTypeEnabled) &&
      (typeDef.itemType !== 'publishedConnection'|| FeatureFlags.publishedConnectionContentManagementEnabled)) {
      if (!showWorkbooksAsViews && typeDef.itemType === 'view') {
        // Showing workbooks only.
        continue;
      } else if (showWorkbooksAsViews && typeDef.itemType === 'workbook') {
        // Showing views instead.
        continue;
      }
      items.push(typeDef);
    }
  }

  return items;
};

const getProjectSpaceMenuItems = (
  currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>,
  contentCounts: ISpaceInfoTypeItemCount<'project'>,
  contentCountsUpToDate: boolean,
  showWorkbooksAsViews: boolean,
  flowsEnabled: boolean
): GenericMenuItemInfo[] => {
  let menuItems: GenericMenuItemInfo[] = ConnectedFilterByTypeMenuHelpers.mapToMenuItems(
    getContentDefinitionsForProjectSpaceMenu(showWorkbooksAsViews, flowsEnabled),
    currentTypeFilters,
    contentCounts,
    contentCountsUpToDate
  );

  menuItems.push({
    value: 'optionsSectionSeparator',
    disabled: true,
    checked: false,
    displayFormatterBoundWithData: ExplorerDropdownSeparatorFormatter()
  });

  menuItems.push({
    value: 'optionsSectionHeader',
    disabled: true,
    checked: false,
    displayFormatterBoundWithData: ExplorerDropdownItemHeaderFormatter(Messages.filterByTypeDropdown_options())
  });

  menuItems.push({
    value: ShowWorkbookAsViewsValue,
    disabled: !showingViewsOrWorkbooks(currentTypeFilters),
    checked: showWorkbooksAsViews,
    displayFormatterBoundWithData: ExplorerDropdownItemNoCountFormatter(Messages.filterByTypeDropdown_showWorkbooksAsViews()),
    keyboardAccessibleValue: Messages.filterByTypeDropdown_showWorkbooksAsViews()
  });

  return menuItems;
};

const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>): boolean => {
  return _.some(currentTypeFilters, (contentType: ExploreContentApi_ContentType) => {
    return contentType === 'workbook'
      || contentType === 'view';
  });
};

const getProjectSpaceMenuItemsWrapper = defaultMemoize(getProjectSpaceMenuItems);

export const mapStateToProjectSpaceProps: MapStateToProps<ExplorerListMenuPanelStateProps> =
  (state: AppState) => {
    const contentCounts = selectContentCounts<'project'>(state, 'project');
    return ConnectedFilterByTypeMenuHelpers.mapStateToProps(state, contentCounts as SpaceInfoTypeContentCounts, getProjectSpaceMenuItemsWrapper);
  };

export const ConnectedFilterByTypeMenu: React.ComponentClass<ExplorerListMenuPanelOwnProps> =
  connect(mapStateToProjectSpaceProps, ConnectedFilterByTypeMenuHelpers.mapDispatchToProps)(ExplorerListMenuPanel);
